import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import { Edit, Delete, CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

const AccountHeader = ({ account, selectedAccounts, toggleAccountSelection, canEdit, editAccount, deleteAccount }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          toggleAccountSelection(account.id);
        }}
        sx={{ p: 0.5 }}
      >
        {selectedAccounts.includes(account.id) ? 
          <CheckBox color="primary" fontSize="small" /> : 
          <CheckBoxOutlineBlank fontSize="small" />
        }
      </IconButton>
      <Typography variant="h6">
        {account.accountName}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      {account.manufacturers.map(mfg => (
        <Chip 
          key={mfg}
          label={mfg} 
          color="primary" 
          size="small" 
        />
      ))}
      <Chip 
        label={`Created: ${account.createdDate.split('T')[0]}`} 
        color="default" 
        size="small" 
      />
      {canEdit && (
        <>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              editAccount(account);
            }}
            title="Edit Account"
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm('Are you sure you want to delete this account?')) {
                deleteAccount(account.id);
              }
            }}
            title="Delete Account"
            color="error"
          >
            <Delete fontSize="small" />
          </IconButton>
        </>
      )}
    </Box>
  </Box>
);

AccountHeader.propTypes = {
  account: PropTypes.object.isRequired,
  selectedAccounts: PropTypes.array.isRequired,
  toggleAccountSelection: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  editAccount: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired
};

export default AccountHeader;